import { Vue } from 'vue-property-decorator'
import Vuex from 'vuex'
import { Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { disableScrolling, enableScrolling } from '../helpers/functions'
import cart from './modules/cart'
import confirmation from './modules/confirmation'
import genericForm from './modules/generic-form'
import mobileMenu from './modules/mobile-menu'
import notifications from './modules/notifications'
import requestDownload from './modules/request-download'
import subscribeNewsletter from './modules/subscribe-newsletter'

@Module({ namespaced: false })
class DefaultStore extends VuexModule {
  showContentOverlay = false

  onOverlayClick: null | (() => void) = null

  @Mutation
  openContentOverlay(onClick?: () => void): void {
    this.showContentOverlay = true
    if (onClick) this.onOverlayClick = onClick
    disableScrolling()
  }

  @Mutation
  closeContentOverlay(): void {
    this.showContentOverlay = false
    this.onOverlayClick = null
    enableScrolling()
  }
}

Vue.use(Vuex)

export default new Vuex.Store({
  state: DefaultStore.state,
  mutations: DefaultStore.mutations,
  actions: DefaultStore.actions,
  getters: DefaultStore.getters,
  modules: {
    mobileMenu,
    notifications,
    requestDownload,
    subscribeNewsletter,
    genericForm,
    cart,
    confirmation
  }
})
